/**
 * External Dependencies
 */
import React from "react"
import { withTheme } from "emotion-theming"
import VisuallyHidden from "@reach/visually-hidden"

/**
 * Internal Dependencies
 */
import Layout from "@layouts/home"
import Slideshow from "@components/slideshow"
import { useSiteMetadata } from "@hooks/useSiteMetadata"
import {
  Community,
  Education,
  Emergency,
  Executive,
  Family,
  Staff,
  Volunteer,
} from "@sections/home"

const SiteIndex = ({ data, theme }) => {
  const { title } = useSiteMetadata()

  return (
    <Layout title={title}>
      <VisuallyHidden>
        <h1>{title}</h1>
      </VisuallyHidden>
      <Slideshow />
      <Executive />
      <Emergency />
      <Family />
      <Community />
      <Education />
      <Volunteer />
      <Staff />
    </Layout>
  )
}

export default withTheme(SiteIndex)
